import React, { Component } from "react";
import { connect } from "react-redux";
import { Button, Input, InputNumber, Select } from "antd";

import { Header, Nav, HamburgerMenu } from "./components";

import {
  loginUserCheck,
  logoutUser,
  productFetchById,
  productUpdate,
} from "../redux/actions";

class AdminEditProduct extends Component {
  constructor() {
    super();
    this.state = {
      id: "",
      product_code: "",
      brand_id: "",
      brand_title: "",
      photo: "",
      oldPhoto: "",
      type: "wall",
      title: "",
      price: "",
      price2: "",
      price3: "",
      price4: "",
      price5: "",
      inventory: "",
      btu: "",
      com: "",
      spare: "",
      size: "",
      air_type: "",
      efficiency: "",
      coil: "",
      swing: "",
      purify: "",
      liquid: "",
      catalog: "",
      description: "",
      order: 0,
      oldOrder: "",
      toggleMenu: false,
    };
  }

  componentWillMount() {
    this.props.loginUserCheck();
    const params = this.getParams();
    this.props.productFetchById(params.id);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.products) {
      const product = nextProps.products[0];
      if (product.price2 === "undefined") product.price2 = 0;
      if (product.price3 === "undefined") product.price3 = 0;
      if (product.price4 === "undefined") product.price4 = 0;
      if (product.price5 === "undefined") product.price5 = 0;
      this.setState({
        id: product.id,
        product_code: product.product_code || "",
        brand_id: product.brand_id,
        brand_title: product.brand_title,
        oldPhoto: product.img,
        type: product.type,
        title: product.title,
        price: product.price,
        price2: product.price2,
        price3: product.price3,
        price4: product.price4,
        price5: product.price5,
        inventory: product.inventory,
        btu: product.btu,
        com: product.com,
        spare: product.spare,
        size: product.size,
        air_type: product.air_type || "",
        efficiency: product.efficiency || "",
        coil: product.coil || "",
        swing: product.swing || "",
        purify: product.purify || "",
        liquid: product.liquid,
        description: product.description || "",
        catalog: product.catalog,
        order: product.order,
        oldOrder: product.order,
      });
    }
  }

  getParams() {
    const str = this.props.location.search;
    let objURL = {};
    str.replace(new RegExp("([^?=&]+)(=([^&]*))?", "g"), ($0, $1, $2, $3) => {
      objURL[$1] = $3;
    });
    return objURL;
  }

  _handleLogout() {
    this.props.logoutUser();
  }

  _onHandleChange(event) {
    if (event.target.files) {
      this.setState({
        [event.target.name]: event.target.files[0],
      });
    } else {
      this.setState({
        [event.target.name]: event.target.value,
      });
    }
  }

  _handleMenu() {
    this.setState({ toggleMenu: !this.state.toggleMenu });
  }

  _onSubmit() {
    const oldPhoto = decodeURIComponent(this.state.oldPhoto.substring(70, 97));
    const {
      product_code,
      brand_id,
      brand_title,
      photo,
      type,
      title,
      price,
      price2,
      price3,
      price4,
      price5,
      inventory,
      btu,
      com,
      spare,
      size,
      air_type,
      efficiency,
      coil,
      swing,
      purify,
      liquid,
      catalog,
      order,
      description,
    } = this.state;
    const data = {
      product_code,
      brand_id,
      brand_title,
      img: photo,
      type,
      title,
      price,
      price2,
      price3,
      price4,
      price5,
      inventory,
      btu,
      com,
      spare,
      size,
      air_type,
      efficiency,
      coil,
      swing,
      purify,
      liquid,
      catalog,
      order,
      description,
      updated_date: new Date().getTime(),
      created_by: this.props.user,
    };
    if (
      // product_code &&
      brand_id &&
      brand_title &&
      title &&
      price &&
      price2 &&
      price3 &&
      price4 &&
      price5 &&
      order
    ) {
      // this.props.productCheckOrder(this.state.id, brand_title, order, this.state.oldOrder)
      this.props.productUpdate(
        this.state.id,
        data,
        oldPhoto,
        this.state.oldOrder
      );
    } else {
      alert("Please fill in a form...");
    }
  }

  render() {
    if (!this.props.user) return <div></div>;
    return (
      <div>
        <Header name={this.props.user} logout={() => this._handleLogout()} />
        <div className="admin-editproduct">
          <Nav active="product" />
          <div
            className={this.state.toggleMenu ? "content moveover" : "content"}
          >
            <div className="content-inner">
              <HamburgerMenu onClick={() => this._handleMenu()} />
              <div className="title">
                <h2>
                  สินค้า : <span className="brandname">{ this.state.brand_title }</span>
                </h2>
              </div>
              <div className="info">
                <div className="adjust">
                  <form className="form-container">
                    <div className="column">
                      <div className="photo">
                        <div className="brand-title">
                          <p>รูปสินค้า :</p>
                        </div>
                        <div className="filename">
                          <p>{this.state.photo.name}</p>
                        </div>
                        <div className="photo-input">
                          <input
                            id="photo"
                            type="file"
                            name="photo"
                            accept="image/*"
                            hidden
                            onChange={(event) => this._onHandleChange(event)}
                          />
                          <label htmlFor="photo">เลือกรูปภาพ</label>
                        </div>
                        <div className="oldphoto">
                          <img src={this.state.oldPhoto} alt="privilege" />
                        </div>
                      </div>
                      <div className="form-item">
                        <p>ประเภท :</p>
                        <Select
                          name="type"
                          value={this.state.type}
                          style={{ width: "100%" }}
                          disabled
                          options={[
                            {
                              value: "wall",
                              label: "แอร์ผนัง",
                            },
                            {
                              value: "hang",
                              label: "แอร์แขวน",
                            },
                            {
                              value: "four",
                              label: "แอร์สี่ทิศทาง",
                            },
                            {
                              value: "concealed",
                              label: "แอรเ์ปลือย",
                            },
                            {
                              value: "stand",
                              label: "แอร์ตู้ตั้ง",
                            },
                            {
                              value: "one_way",
                              label: "แอร์หนึ่งทิศทาง",
                            },
                          ]}
                        />
                      </div>
                      <div className="form-item">
                        <p>รุ่น :</p>
                        <Input
                          name="title"
                          value={this.state.title}
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>รหัสสินค้า :</p>
                        <Input
                          name="product_code"
                          value={this.state.product_code}
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>ราคา (Rank 1) :</p>
                        <Input
                          name="price"
                          value={this.state.price}
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>ราคา (Rank 2) :</p>
                        <Input
                          name="price2"
                          value={this.state.price2}
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>ราคา (Rank 3) :</p>
                        <Input
                          name="price3"
                          value={this.state.price3}
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>ราคา (Rank 4) :</p>
                        <Input
                          name="price4"
                          value={this.state.price4}
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>ราคา (Rank 5) :</p>
                        <Input
                          name="price5"
                          value={this.state.price5}
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>จำนวนคงเหลือ :</p>
                        <Input
                          name="inventory"
                          value={this.state.inventory}
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>BTU :</p>
                        <Input
                          name="btu"
                          value={this.state.btu}
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                    </div>
                    <div className="column">
                      <div className="form-item" style={{ marginTop: 0 }}>
                        <p>ประกันคอม :</p>
                        <Input
                          name="com"
                          value={this.state.com}
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>ประกันอะไหล่ :</p>
                        <Input
                          name="spare"
                          value={this.state.spare}
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>ไซส์ท่อ :</p>
                        <Input
                          name="size"
                          value={this.state.size}
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>ระบบ :</p>
                        <Select
                          name="air_type"
                          value={this.state.air_type || null}
                          onChange={(value) => this.setState({ air_type: value })}
                          style={{ width: "100%" }}
                          placeholder="กรุณาเลือกระบบ"
                          options={[
                            {
                              value: "INVERTER",
                              label: "INVERTER",
                            },
                            {
                              value: "FIXSPEED",
                              label: "FIXSPEED",
                            },
                          ]}
                        />
                      </div>
                      <div className="form-item">
                        <p>เบอร์ 5 :</p>
                        <Select
                          name="efficiency"
                          value={this.state.efficiency || null}
                          onChange={(value) => this.setState({ efficiency: value })}
                          style={{ width: "100%" }}
                          placeholder="กรุณาเลือกเบอร์ 5"
                          options={[
                            {
                              value: "ไม่มีเบอร์ 5",
                              label: "ไม่มีเบอร์ 5",
                            },
                            {
                              value: "เบอร์ 5 : ไม่มีดาว",
                              label: "เบอร์ 5 : ไม่มีดาว",
                            },
                            {
                              value: "เบอร์ 5 : 1 ดาว",
                              label: "เบอร์ 5 : 1 ดาว",
                            },
                            {
                              value: "เบอร์ 5 : 2 ดาว",
                              label: "เบอร์ 5 : 2 ดาว",
                            },
                            {
                              value: "เบอร์ 5 : 3 ดาว",
                              label: "เบอร์ 5 : 3 ดาว",
                            },
                            {
                              value: "เบอร์ 5 : 4 ดาว",
                              label: "เบอร์ 5 : 4 ดาว",
                            },
                            {
                              value: "เบอร์ 5 : 5 ดาว",
                              label: "เบอร์ 5 : 5 ดาว",
                            },
                          ]}
                        />
                      </div>
                      <div className="form-item">
                        <p>คอยล์ :</p>
                        <Select
                          name="coil"
                          value={this.state.coil || null}
                          onChange={(value) => this.setState({ coil: value })}
                          style={{ width: "100%" }}
                          placeholder="กรุณาเลือกคอยล์"
                          options={[
                            {
                              value: "ทองแดง",
                              label: "ทองแดง",
                            },
                            {
                              value: "อลูมิเนียม",
                              label: "อลูมิเนียม",
                            },
                          ]}
                        />
                      </div>
                      <div className="form-item">
                        <p>สวิง :</p>
                        <Select
                          name="swing"
                          value={this.state.swing || null}
                          onChange={(value) => this.setState({ swing: value })}
                          style={{ width: "100%" }}
                          placeholder="กรุณาเลือกสวิง"
                          options={[
                            {
                              value: "ขึ้นลง",
                              label: "ขึ้นลง",
                            },
                            {
                              value: "ขึ้นลง - ซ้ายขวา",
                              label: "ขึ้นลง - ซ้ายขวา",
                            },
                          ]}
                        />
                      </div>
                      <div className="form-item">
                        <p>ฟอกอากาศ :</p>
                        <Select
                          name="purify"
                          value={this.state.purify || null}
                          onChange={(value) => this.setState({ purify: value })}
                          style={{ width: "100%" }}
                          placeholder="กรุณาเลือกฟอกอากาศ"
                          options={[
                            {
                              value: "แผ่นฟอก",
                              label: "แผ่นฟอก",
                            },
                            {
                              value: "ฟอกไฟฟ้า",
                              label: "ฟอกไฟฟ้า",
                            },
                            {
                              value: "ไม่มีระบบฟอก",
                              label: "ไม่มีระบบฟอก",
                            },
                          ]}
                        />
                      </div>
                      <div className="form-item">
                        <p>น้ำยา :</p>
                        <Input
                          name="liquid"
                          value={this.state.liquid}
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>แคตตาล็อก :</p>
                        <Input
                          name="catalog"
                          value={this.state.catalog}
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                      <div className="form-item">
                        <p>อันดับ :</p>
                        <InputNumber
                          name="order"
                          min={1}
                          value={this.state.order}
                          onChange={(value) => this.setState({ order: value })}
                          style={{ width: "100%" }}
                        />
                      </div>
                      <div className="form-item">
                        <p>รายละเอียดเพิ่มเติม :</p>
                        <Input.TextArea
                          name="description"
                          value={this.state.description}
                          onChange={(event) => this._onHandleChange(event)}
                        />
                      </div>
                    </div>
                  </form>

                  <div
                    className="action-button"
                    style={{
                      marginBottom: "20px",
                      paddingLeft: "187px",
                      paddingTop: 0,
                    }}
                  >
                    {this.props.loading || this.state.price === "" ? (
                      <div>
                        <p style={{ textAlign: "left" }}>Loading...</p>
                      </div>
                    ) : (
                      <div>
                        <Button type="primary" onClick={() => this._onSubmit()}>
                          บันทึก
                        </Button>
                        <Button onClick={() => window.history.back()}>
                          กลับ
                        </Button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ auth, product }) => {
  return {
    user: auth.user,
    loading: product.loading,
    products: product.products,
  };
};

export default connect(mapStateToProps, {
  loginUserCheck,
  logoutUser,
  productFetchById,
  productUpdate,
})(AdminEditProduct);
